import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { fromJS, List, Map } from 'immutable'

import { RadioButton } from 'primereact/radiobutton'

import style from '@aytm/app/stats/page/sidebar/color-options/styles/ColorOptionsPanel.module.scss'

const ColorThemes = ({
  colorThemes,
  reportColorTheme,
  palettes,
  reportPalette,
  isAdmin,
  isSurveyOwner,
  disabled,
  onSelect,
  onPaletteAdd
}) => {
  const copyAvailable = useMemo(
    () => 3 > palettes.size && (isAdmin || isSurveyOwner) && !disabled,
    [palettes, isAdmin, isSurveyOwner, disabled]
  )

  const showReportPalette = useMemo(
    () => null !== reportPalette && !palettes.some(palette => reportPalette.equals(palette.get('data'))),
    [palettes, reportPalette]
  )

  const onColorThemeSelect = value => {
    if ('number' == typeof value) onSelect(value, null)
    else onSelect(null, value)
  }

  const onColorThemeCopy = value => {
    if ('number' == typeof value) {
      const palette = fromJS({
        colors: colorThemes.get(value).slice(0, 7),
        saturation: 10,
        luminosity: 15
      })
      onPaletteAdd(palette)
    } else {
      onPaletteAdd(value)
    }
  }

  return (
    <div className={style['palettes-list']}>
      {colorThemes.map((colorTheme, index) => (
        <div key={`colorTheme-${index}`} className={style['palettes-list-item']}>
          <RadioButton
            checked={null !== reportColorTheme && reportColorTheme == index}
            disabled={disabled}
            onChange={disabled ? null : () => onColorThemeSelect(index)}
          />
          <div
            className={classNames(style['palettes-list-item-colors'], { 'p-disabled': disabled })}
            onClick={disabled ? null : () => onColorThemeSelect(index)}
          >
            {colorTheme.map((color, colorIndex) =>
              7 > colorIndex ? (
                <span
                  key={`colorTheme-${index}-color-${colorIndex}`}
                  className={style['palettes-list-item-colors-item']}
                  style={{ backgroundColor: color }}
                ></span>
              ) : null
            )}
          </div>
          {copyAvailable && (
            <span className={style['palettes-list-item-edit']} onClick={() => onColorThemeCopy(index)}>
              copy
            </span>
          )}
        </div>
      ))}
      {showReportPalette && (
        <div className={style['palettes-list-item']}>
          <RadioButton
            disabled={disabled}
            checked={true}
            onChange={disabled ? null : () => onColorThemeSelect(reportPalette)}
          />
          <div
            className={classNames(style['palettes-list-item-colors'], { 'p-disabled': disabled })}
            onClick={disabled ? null : () => onColorThemeSelect(reportPalette)}
          >
            {reportPalette.get('colors').map((color, colorIndex) => (
              <span
                key={`colorTheme-custom-color-${colorIndex}`}
                className={style['palettes-list-item-colors-item']}
                style={{ backgroundColor: color }}
              ></span>
            ))}
          </div>
          {copyAvailable && (
            <span className={style['palettes-list-item-edit']} onClick={() => onColorThemeCopy(reportPalette)}>
              copy
            </span>
          )}
        </div>
      )}
    </div>
  )
}

ColorThemes.propTypes = {
  colorThemes: PropTypes.instanceOf(List),
  reportColorTheme: PropTypes.number,
  palettes: PropTypes.instanceOf(List),
  reportPalette: PropTypes.instanceOf(Map),
  isAdmin: PropTypes.bool,
  isSurveyOwner: PropTypes.bool,
  isSurveyGuest: PropTypes.bool,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
  onPaletteAdd: PropTypes.func
}

ColorThemes.displayName = 'ColorThemes'

export default ColorThemes
